import { Link } from 'react-router-dom';

interface ManhwaCardProps {
  id: number;
  title: string;
  author: string;
  category: string;
  slug: string;
  cover: string;
  rating: number;
  chapters: number;
  views: number;
  tags: string[];
  variant?: 'default' | 'featured';
}

export default function ManhwaCard({ title, author, category, slug, cover, rating, chapters, tags, variant = 'default' }: ManhwaCardProps) {
  if (variant === 'featured') {
    return (
      <Link
        to={`/article/${slug}`}
        className="group block bg-white rounded-lg border border-background-200 overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer"
      >
        <div className="relative aspect-[3/4] overflow-hidden">
          <img
            src={cover}
            alt={title}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            loading="lazy"
            title={`${title} - 虚空韩漫网`}
          />
          <div className="absolute top-2 left-2">
            <span className="px-2 py-0.5 text-xs font-medium bg-accent-500 text-white rounded-full">
              {rating}
            </span>
          </div>
          <div className="absolute top-2 right-2">
            <span className="px-2 py-0.5 text-xs bg-black/60 text-white rounded-full backdrop-blur-sm">
              {chapters}话
            </span>
          </div>
        </div>
        <div className="p-3 md:p-4">
          <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
            {title}
          </h3>
          <p className="text-xs text-foreground-500 mt-1">{author} · {category}</p>
          <div className="flex flex-wrap gap-1.5 mt-2">
            {tags.slice(0, 3).map((tag) => (
              <span key={tag} className="px-2 py-0.5 text-xs bg-secondary-100 text-secondary-700 rounded-md">
                {tag}
              </span>
            ))}
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/article/${slug}`}
      className="group block bg-white rounded-lg border border-background-200 overflow-hidden hover:border-accent-300 transition-all duration-300 cursor-pointer"
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={cover}
          alt={title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
          title={`${title} - 虚空韩漫网`}
        />
        <div className="absolute top-2 right-2">
          <span className="px-2 py-0.5 text-xs bg-accent-500 text-white rounded-full font-medium">
            {rating}
          </span>
        </div>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="text-sm font-heading font-semibold text-foreground-900 group-hover:text-accent-600 transition-colors line-clamp-1">
          {title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1">{author}</p>
      </div>
    </Link>
  );
}